import { useState } from 'react';

import { CognitoUser } from '../../../types/user';

export function useChallengeUser() {
  const [challengeUser, setChallengeUser] = useState<CognitoUser | null>(null);

  return {
    challengeUser,
    setChallengeUser,
  };
}
